import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-case-list',
  templateUrl: './case-list.component.html',
  styleUrls: ['./case-list.component.css']
})
export class CaseListComponent {
  constructor(
    private dialogRef: MatDialogRef<CaseListComponent>,
    @Inject(MAT_DIALOG_DATA) private data: CaseListInput,
    private router: Router
  ) {
    this.caseCategory = this.data.caseCategory;
    this.caseList = this.data.caseList;
    this.printMode = this.data.printMode;
  }

  caseCategory: any;
  caseList: any;
  printMode: boolean = false;

  ngAfterViewInit() {
    console.log(this.caseList);
    if (this.printMode) {
      setTimeout(() => {
        window.print();
        this.onCloseModal(null);
      }, 500);
    }
  }

  onCloseModal(event: any){
    this.dialogRef.close();
  }

  goToLink(id: any) {
    var link = `case/${id}/true`
    // window.open(link);
    this.router.navigate([link], {
      state: this.data
    });
    this.dialogRef.close();
  }
}

interface CaseListInput {
  caseCategory: any,
  caseList: any,
  printMode: boolean,
  quarter: number,
  year: number,
  jurisdiction: string,
  scrolledSectionId: string
}